/* eslint-disable class-methods-use-this */
class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.currentWidth = window.innerWidth;
  }

  connectedCallback() {
    this.readMoreButton = this.querySelector('.read-more__button');
    this.contentWrapper = this.querySelector('.read-more__content');
    this.standardizeContentStructure(this.contentWrapper);
    this.contentContainer = this.querySelector('.read-more__content > p');

    this.readMoreButton.addEventListener('click', () => {
      this.toggleDescriptionExpansion();
    });

    this.updateReadMoreVisibility();

    this.handleResize = this.debounce(() => {
      if (window.innerWidth != this.currentWidth) {
        this.currentWidth = window.innerWidth;
        if (this.readMoreButton.getAttribute('aria-expanded') == 'true') {
          this.toggleDescriptionExpansion();
        }
        this.updateReadMoreVisibility();
      }
    }, 150);

    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  updateReadMoreVisibility() {
    const clampedHeight = this.contentContainer.clientHeight;
    const fullHeight = this.contentContainer.scrollHeight;

    // Drive button visibility through an attribute so the CSS can decide whether
    // to hide the button outright or keep its space reserved (reserve-space variant).
    this.toggleAttribute('data-needs-read-more', clampedHeight < fullHeight);
  }

  toggleDescriptionExpansion() {
    if (this.readMoreButton.getAttribute('aria-expanded') != 'true') {
      this.readMoreButton.setAttribute('aria-expanded', 'true');
    } else {
      this.readMoreButton.setAttribute('aria-expanded', 'false');
    }

    this.readMoreButton.textContent =
      this.readMoreButton.getAttribute('aria-expanded') == 'true' ? 'Read less' : 'Read more';
  }

  standardizeContentStructure(input) {
    if (!input) return null;

    const clonedContent = input.cloneNode(true);
    clonedContent.querySelectorAll('style, script, noscript').forEach((el) => el.remove());

    const paragraphInputs = Array.from(clonedContent.querySelectorAll('p'));
    const referenceParagraphs = paragraphInputs.length > 0 ? paragraphInputs : [clonedContent];

    const paragraphs = referenceParagraphs.map((p) => p.textContent.trim()).filter((text) => text.length > 0);

    const finalParagraph = document.createElement('p');

    paragraphs.forEach((text, index) => {
      finalParagraph.appendChild(document.createTextNode(text));
      if (index < paragraphs.length - 1) {
        finalParagraph.appendChild(document.createElement('br'));
        finalParagraph.appendChild(document.createElement('br'));
      }
    });

    input.replaceChildren(finalParagraph);
  }
}

if (!customElements.get('read-more')) {
  window.customElements.define('read-more', ReadMore);
}
